import React from 'react';
import { useState } from 'react'
import './About.css'
import bgth3 from '../../images/bgth2.jpg'


const AboutUs = () => {

    return (
        <div className='mainaboutus'>
            <div className="about-section">
                <div className="about-content" style={{ backgroundImage: `url(${bgth3})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover',width:'auto' }}>
                    <h1 className="about-title">
                        Movement 
                        <br />
                        is the Key to 
                        <br />
                        Wellness.
                    </h1>

                </div>
            </div>
            <div className='contentofabout'>
                <section className="our-story">
                    <h2 className="story-title">Cancellation Policy</h2>
                    <p className="story-text">
                        At MantraFlex, we know life happens—kids get sick, cars break down, or maybe Netflix releases another 
                        binge-worthy series. We get it. But here’s the thing: when you skip an appointment without letting us 
                        know, our therapists sit around pretending to be busy… and that’s just awkward for everyone. So, here’s 
                        how we roll:
                    </p>
                    <ol>
                        <li><strong>Give Us a Heads-Up (24 Hours, Please!):</strong><br/>
                            <ul>
                                <li>
                                    If you need to cancel or reschedule, let us know at least 24 hours in advance. That way, 
                                    we can fill your spot with someone else who needs our magic touch—or at least go grab a 
                                    coffee guilt-free.
                                </li>
                            </ul>
                        </li>
                        <li><strong>Cancellation Fees Are Real:</strong>
                            <ul>
                                <li>
                                    If you cancel within less than 24 hours or pull a no-show, we may have to charge you a 
                                    “We Missed You Fee” of [insert amount or percentage]. Trust us, we’d rather see your face 
                                    than your money, but fair is fair.
                                </li>
                                <li>
                                    No-shows? They’re even sadder and will also be charged.
                                </li>
                            </ul>
                        </li>
                        <li><strong>How to Break Up With Your Appointment:</strong><br/>
                            <span style={{ color: 'black', fontWeight: 'bold'}}>You can cancel or reschedule by:</span><br/>
                            <ul>
                                <li>Calling us at [insert number]</li>
                                <li>Emailing [insert email]</li>
                                <li>Using our online booking system (no ghosting, please).</li>
                            </ul>

                        </li>
                        <li><strong>Emergency Clauses</strong>
                            <ul>
                                <li>
                                    We know life isn’t always predictable. If a true emergency comes up, just give us a shout, 
                                    and we’ll cut you some slack. (But if your “emergency” involves Netflix or snoozing your 
                                    alarm, we might still charge you.)
                                </li>
                            </ul>
                        </li>
                        <li><strong>Chronic Canceller? Let’s Talk.</strong>
                            <ul>
                                <li>
                                    If cancellations become your thing, we may kindly ask for prepayment to secure future 
                                    appointments. No hard feelings—we’re just trying to keep our schedule happy and healthy.
                                </li>
                            </ul>
                        </li>
                    </ol>

                    <p>
                        In short, we love seeing you. If something comes up, let us know ASAP so we can keep helping you 
                        (and others) move better, live stronger, and laugh harder. Thanks for keeping us in the loop!
                    </p>
                </section>
            </div>
        </div>

    )
}

export default AboutUs